import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const white: string = ui.white[500];
const grey: string = ui.neutral[400];

export const dropdownButtonCss = (isMobile = false, isUpdateMode = false) => {
  const isStandaloneButton = isMobile && isUpdateMode;

  return {
    borderLeft: `1px solid ${white}`,
    borderTopLeftRadius: isStandaloneButton ? "8px" : "0",
    borderBottomLeftRadius: isStandaloneButton ? "8px" : "0",
    ...(isMobile
      ? {
          height: "32px",
          padding: "8px",
        }
      : {}),
  };
};

export const dropdownItemCss = {
  display: "flex",
  justifyContent: "flex-start",
  whiteSpace: "nowrap",
};

const iconCss = {
  display: "inline",
  height: "20px",
  marginRight: "0.5em",
  verticalAlign: "text-bottom",
  path: {
    stroke: grey,
  },
};

export const cogIconCss = {
  ...iconCss,
  path: {
    stroke: grey,
    strokeWidth: 1,
    fill: grey,
  },
};

export const copyIconCss = {
  ...iconCss,
  path: {
    stroke: grey,

    ":nth-of-type(even)": {
      fill: grey,
    },
  },
};

export const popOutCss = {
  zIndex: 14,
};
